module.exports = __webpack_public_path__ + "img/icons B_25.3f58db7b.png";